module.exports = __webpack_public_path__ + "assets/img/Type BS (7).a4311024.jpg";